import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconWand12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconWand12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Wand12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M9.686 1.351 8.376 2.66l.964.963 1.309-1.309zM1.35 9.685l6.32-6.318.963.963-6.318 6.319zm-.707-.707a1 1 0 0 0 0 1.414l.964.964a1 1 0 0 0 1.414 0l8.334-8.334a1 1 0 0 0 0-1.415l-.963-.963a1 1 0 0 0-1.415 0zM2.501.51a.5.5 0 0 1 .5.5v1.004h1.006a.5.5 0 1 1 0 1H3.001v1.01a.5.5 0 0 1-1 0v-1.01H.993a.5.5 0 0 1 0-1h1.008V1.009a.5.5 0 0 1 .5-.5m5.044 8.823a.5.5 0 0 1 .5.5v.242h.233a.5.5 0 1 1 0 1h-.233v.223a.5.5 0 0 1-1 0v-.223h-.233a.5.5 0 0 1 0-1h.233v-.242a.5.5 0 0 1 .5-.5M9.993 6.5a.5.5 0 0 0-1 0v.597h-.6a.5.5 0 0 0 0 1h.6v.601a.5.5 0 1 0 1 0v-.601h.599a.5.5 0 1 0 0-1h-.6z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Wand12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconWand12);
